export function handleZoomToAgent(e) {
  const coordinates = e?.detail?.coordinates;
  const feature = e?.detail?.feature;
  if (
    !this.map ||
    !Array.isArray(coordinates) ||
    coordinates.length < 2 ||
    typeof coordinates[0] !== 'number' ||
    typeof coordinates[1] !== 'number'
  ) {
    return;
  }

  const [lng, lat] = coordinates;
  this.skipNextMoveEndFetch = true;
  this.zoomToAgentFeature =
    feature && feature.geometry && feature.properties
      ? {
          type: 'Feature',
          geometry: feature.geometry,
          properties: feature.properties
        }
      : null;

  this.map.easeTo({
    center: [lng, lat],
    zoom: 12,
    duration: 500
  });

  if (this.map.getLayer('Agents')) {
    this.map.moveLayer('Agents');
  }

  this.ensureZoomToAgentOverlayLayer();
  this.updateZoomToAgentOverlay();
}

export function getAgentIconImageExpression() {
  return [
    'match',
    ['get', 'age'],
    ['moreThanDay'],
    'pulsing-red-dot',
    ['moreThanDay_clicked'],
    'large-pulsing-red-dot',
    ['lessThanDay'],
    'pulsing-orange-dot',
    ['lessThanDay_clicked'],
    'large-pulsing-orange-dot',
    ['lessThanHour'],
    'pulsing-green-dot',
    ['lessThanHour_clicked'],
    'large-pulsing-green-dot',
    ['moreThanWeek'],
    'static-gray-dot',
    ['moreThanWeek_clicked'],
    'static-gray-pin',
    ['cluster_clicked'],
    'large-pulsing-green-dot',
    'pulsing-red-dot'
  ];
}

export function ensureZoomToAgentOverlayLayer() {
  if (!this.map) return;

  if (!this.map.getSource('Agents_zoom_source')) {
    this.map.addSource('Agents_zoom_source', {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: []
      }
    });
  }

  if (!this.map.getLayer('Agents_zoom_highlight')) {
    this.map.addLayer({
      id: 'Agents_zoom_highlight',
      source: 'Agents_zoom_source',
      type: 'symbol',
      layout: {
        visibility: this.props.selectedLayers.includes('Agents')
          ? 'visible'
          : 'none',
        'icon-image': this.getAgentIconImageExpression(),
        'icon-size': 0.3,
        'icon-padding': 0,
        'symbol-avoid-edges': true,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true
      },
      paint: {
        'icon-opacity': 1
      }
    });
  }
}

export function updateZoomToAgentOverlay() {
  if (!this.map) return;
  this.ensureZoomToAgentOverlayLayer();

  const src = this.map.getSource('Agents_zoom_source');
  if (!src) return;

  src.setData({
    type: 'FeatureCollection',
    features: this.zoomToAgentFeature ? [this.zoomToAgentFeature] : []
  });

  if (this.map.getLayer('Agents_zoom_highlight')) {
    this.map.moveLayer('Agents_zoom_highlight');
  }
}
